/**
 * 測試的WebviewCallbackObject
 * 模擬local建立一個JavascriptInterface
 * localStorage建立個key為"testAppCallback", value為1的資料reload後即可使用(main.js可調整設定)
 */
class mockWebviewCallbackObject {
  callHandler(methodName, ...args) {
    return new Promise((resolve, reject) => {
      let result = undefined
      console.info('[Webview] callback methodName', methodName)
      console.info('args', args)
      if(methodName === 'isApple') {
        result = true
      }
      resolve(result)
    })
  }
}

export default new mockWebviewCallbackObject()